//员工管理  Staff Property Group
import http from '../httpConfig'

const table = "mrbase_sys_staff_property_group"


// 获取Staff Property Group列表接口
export const getStaffPropertyGroup = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-property/list-group/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// 获取新增的List
export const getAddList = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-property/get-allProperty/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


// Staff Property Group详情接口
export const getStaffPropertyGroupDetail = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-property/find-group/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

// Staff Property Group属性详情接口
export const getPropertyGroupDetail = (params = {}) => {
  params['~table~'] = 'mrbase_sys_staff_property_group_default_value'
  return new Promise((resolve, reject) => {
    http.post('/api/staff-property/find-property/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//Staff Property Group删除
export const deleteStaffPropertyGroup = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-property/delete-group/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//Staff Property Group更新
export const updateStaffPropertyGroup = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-property/update-group/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//Staff Property Group新增
export const addStaffPropertyGroup = (params = {}) => {
  params['~table~'] = table
  return new Promise((resolve, reject) => {
    http.post('/api/staff-property/add-group/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//
//员工新增接口
export const add_staff_manager = (params = {}) => {
  params['~table~'] = 'mrbase_sys_staffs'
  return new Promise((resolve, reject) => {
    http.post('/api/staff-manager/add-staff/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

//验证员工ID
export const verificationStaffId = (params = {}) => {
  params['~table~'] = 'mrbase_sys_staffs'
  return new Promise((resolve, reject) => {
    http.post('/api/staff-manager/staffCode-valitation/v1', params)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}